<template>
	<div class="auth activate">
		<h1>{{ $t('base.auth.account_activation') }}</h1>
		<spinner v-if="loading"/>
		<div v-else>
			<div v-if="success">
				<div class="alert alert-success">{{ success }}</div>
				<router-link class="btn btn-primary btn-round" :to="{ name: 'AuthLogin' }">Sign In</router-link>
			</div>
			<error-box v-if="error" :error="error"/>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'hash'
	],
	data () {
		return {
			loading: false,
			success: null,
			error: null
		}
	},
	methods: {
		activate () {
			this.loading = true
			this.$api.auth.activate(this, { hash: this.hash }).then(response => {
				this.$log.info('user activate', 'auth.activate OK', response)()
				this.success = response.body.message
			}).catch((errors) => {
				this.$log.error('user activate', 'auth.activate ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.account_activation'))
	},
	mounted () {
		this.activate()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/AuthActivate.vue